export interface IProductDeliveryStatus {
  id?: number;
  status?: string;
}

export const defaultValue: Readonly<IProductDeliveryStatus> = {};
